import { ref, nextTick, onMounted, type ComputedRef } from 'vue';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

export function useSideMenuScroll(
  menu: ComputedRef<Array<any>>,
  setFormattedMenu: (menu: Array<any>) => void,
  compactLayout: () => void
) {
  const scrollableRef = ref<HTMLDivElement>();

  onMounted(async () => {
    setFormattedMenu(menu.value);
    await nextTick();

    // Use setTimeout to ensure DOM updates are flushed, as in the original code.
    await new Promise(resolve => setTimeout(resolve, 100));
    const el = scrollableRef.value;
    if (
      el &&
      !el.getAttribute('data-simplebar') &&
      !el.classList.contains('simplebar-wrapper') &&
      el.children.length > 0
    ) {
      new SimpleBar(el);
    }
    compactLayout();
    window.onresize = () => compactLayout();
  });

  return { scrollableRef };
}

